import { AxiosResponse } from 'axios';
import { ICredit } from 'hooks/useCredits/types';
import { API } from '../providers/ApiInterceptorProvider';

export const fetchCreditsDetails = (id: string): Promise<AxiosResponse<ICredit[]>> =>
  API.get(`/legacy-underwriter/credits?applicationRefNo=${id}`);
